export default __webpack_public_path__ + "static/media/mobil.f8782366.png";